/**
 * 생성기 자료 칩의 메타 줄 — Figma `.AIGen/AttachmentChip`: 유튜브 「youtube.com · 12:34」,
 * 웹 「ko.wikipedia.org」.
 */
import { type AiGenerateDockLinkSourceType } from '../consts/aiGenerateDock.const';

import { YOUTUBE_HOSTS } from './aiGenerateDockAttachment';

/** 칩 메타 줄의 도메인 — 유튜브는 www.·m.·youtu.be 를 「youtube.com」으로 모은다. */
export const formatAiGenerateDockLinkHost = (
  sourceType: AiGenerateDockLinkSourceType,
  url: string,
): string => {
  let host: string;
  try {
    host = new URL(url).hostname.toLowerCase();
  } catch {
    return url;
  }
  if (sourceType !== 'youtube') return host;
  return YOUTUBE_HOSTS.some(
    youtubeHost => host === youtubeHost || host.endsWith(`.${youtubeHost}`),
  )
    ? 'youtube.com'
    : host;
};

/** 영상 길이 — 12:34, 한 시간 이상은 1:02:03. */
export const formatAiGenerateDockDuration = (totalSeconds: number): string => {
  const seconds = Math.max(0, Math.floor(totalSeconds));
  const hours = Math.floor(seconds / 3600);
  const minutes = Math.floor((seconds % 3600) / 60);
  const rest = String(seconds % 60).padStart(2, '0');
  return hours > 0
    ? `${hours}:${String(minutes).padStart(2, '0')}:${rest}`
    : `${minutes}:${rest}`;
};
